import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { filterObj } from '@/utils/util';
import { getUserList } from '@/api/api';
export default {
  name: "SelectUserListModal",
  components: {},
  data: function data() {
    return {
      title: "选择用户",
      queryParam: {},
      columns: [{
        title: '用户账号',
        align: "center",
        dataIndex: 'username',
        fixed: 'left',
        width: 200
      }, {
        title: '真实姓名',
        align: "center",
        dataIndex: 'realname'
      }, {
        title: '性别',
        align: "center",
        dataIndex: 'sex',
        customRender: function customRender(text) {
          if (text == 1) {
            return "男";
          } else if (text == 2) {
            return "女";
          } else {
            return text;
          }
        }
      }, {
        title: '手机号码',
        align: "center",
        dataIndex: 'phone'
      }, {
        title: '邮箱',
        align: "center",
        dataIndex: 'email'
      }, {
        title: '状态',
        align: "center",
        dataIndex: 'status',
        customRender: function customRender(text) {
          if (text == 1) {
            return "正常";
          } else if (text == 2) {
            return "冻结";
          } else {
            return text;
          }
        }
      }],
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '20'],
        showTotal: function showTotal(total, range) {
          return range[0] + "-" + range[1] + " 共" + total + "条";
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      selectedRowKeys: [],
      selectionRows: [],
      visible: false,
      toggleSearchStatus: false
    };
  },
  created: function created() {
    this.loadData();
  },
  methods: {
    add: function add(selectUser, userIds) {
      this.visible = true;
      this.edit(selectUser, userIds);
    },
    edit: function edit(selectUser, userIds) {
      if (!userIds) {
        this.selectedRowKeys = [];
      } else {
        this.selectedRowKeys = userIds.split(',');
      }

      if (!selectUser) {
        this.selectionRows = [];
      } else {
        this.selectionRows = selectUser;
      }
    },
    loadData: function loadData(arg) {
      var _this = this;

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      getUserList(params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;
          _this.ipagination.total = res.result.total;
        }
      });
    },
    getQueryParams: function getQueryParams() {
      var param = Object.assign({}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField: function getQueryField() {
      var str = "id,";

      for (var a = 0; a < this.columns.length; a++) {
        str += "," + this.columns[a].dataIndex;
      }

      return str;
    },
    onSelectChange: function onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      console.log(this.selectedRowKeys);
      this.selectionRows = selectionRows;
    },
    searchReset: function searchReset() {
      var that = this;
      Object.keys(that.queryParam).forEach(function (key) {
        that.queryParam[key] = '';
      });
      that.loadData(1);
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc";
      }

      this.ipagination = pagination;
      this.loadData();
    },
    handleCancel: function handleCancel() {
      this.selectionRows = [];
      this.selectedRowKeys = [];
      this.visible = false;
    },
    handleOk: function handleOk() {
      this.$emit("choseUser", this.selectionRows);
      this.handleCancel();
    },
    searchByquery: function searchByquery() {
      this.loadData(1);
    },
    handleToggleSearch: function handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    }
  }
};